'use client';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Badge } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { PlayerData, UserImage } from '@/types/players.types';
import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

type OverviewImageWrapperProps = {
  playerData: PlayerData | undefined;
};

export const OverviewImageWrapper = ({ playerData }: OverviewImageWrapperProps) => {
  const [overviewImageWidth, setOverviewImageWidth] = useState(0);
  const [overviewImage, setOverviewImage] = useState<UserImage | undefined>();

  useEffect(() => {
    // TODO: Move this logic to backend to avoid layout shifts
    const images = playerData?.images || [];
    const actionImages = images.filter((image) => image.type === 'actionUserImg');
    const image = actionImages.at(-1);

    setOverviewImage(image);

    if (image) {
      const tempImage = new window.Image();
      tempImage.src = image.url;
      tempImage.onload = () => {
        setOverviewImageWidth(tempImage.width);
      };
    }
  }, [playerData?.images]);

  const fallbackSrc = getCDNURL(PICKLEBALL_PLACEHOLDER_IMAGE, 350, 350);

  return (
    <div
      className={clsx(
        'relative mb-10 h-[215px] w-full shrink-0 overflow-auto rounded-xl shadow-md sm:mb-0 sm:w-1/3 md:mt-0',
        !overviewImage?.url && 'hidden sm:block'
      )}
    >
      {overviewImage && overviewImage.totalApprovals < 2 && !overviewImage.dateOfRejection ? (
        <Badge
          label='Pending approval'
          size='md'
          variation='warning'
          className='!absolute right-2 top-2'
        />
      ) : null}
      {overviewImage && overviewImage.dateOfRejection ? (
        <Badge label='Declined' size='md' variation='error' className='!absolute right-2 top-2' />
      ) : null}
      <ImageWithFallback
        src={overviewImage ? getCDNURL(overviewImage.url, 350, 350) : fallbackSrc}
        fill
        alt='Overview Image'
        className={overviewImageWidth < 215 ? 'object-contain' : 'object-cover'}
      />
    </div>
  );
};
